import { IAddress } from './interfaces';

export const computeAddresses = (addresses: IAddress[]) => {
  const completeAddresses: IAddress[] = [];
  const incompleteAddresses: IAddress[] = [];
  let newIncompleteAddresses = 0;

  addresses?.forEach(address => {
    if (address?.addressGood) {
      completeAddresses.push(address);
      return;
    }

    if (!address?.addressGood) {
      incompleteAddresses.push(address);
      if (address.new) newIncompleteAddresses += 1;
    }
  });

  return {
    completeAddresses,
    incompleteAddresses,
    newIncompleteAddresses
  };
};

export enum clusterLabelsEnum {
  VKYC = 'VKYC location',
  DATA_SUTRAM = 'Customer Outreach'
}

export const GEO_LOCATION_PAGE_SIZE = 100;
export const MAX_FEEDBACK_STATUS_CHAR_LENGTH = 28;

export enum AddressSource {
  SKIP_TRACING = 'SKIP_TRACING'
}

export interface AddAddressFormValues {
  lineOne: string;
  lineTwo: string;
  pinCode: string;
  city: string;
  sourceOfAddress: string;
  recentActivityDate: string;
  proofOfSource: File | null;
}

export const defaultValues: AddAddressFormValues = {
  lineOne: '',
  lineTwo: '',
  pinCode: '',
  city: '',
  sourceOfAddress: '',
  recentActivityDate: '',
  proofOfSource: null
};

// Dummy options for Source of Address dropdown
export const SOURCE_OF_ADDRESS_OPTIONS = [
  { label: 'Gas & Electricity Bill', value: 'GAS_ELECTRICITY_BILL' },
  { label: 'Experian', value: 'EXPERIAN' },
  { label: 'Facebook', value: 'FACEBOOK' },
  { label: 'Google Search', value: 'GOOGLE_SEARCH' },
  { label: 'Just Dial', value: 'JUST_DIAL' },
  { label: 'Onground Sources', value: 'ONGROUND_SOURCES' },
  { label: 'YouTube', value: 'YOUTUBE' },
  { label: 'Instagram', value: 'INSTAGRAM' },
  { label: 'Extensions', value: 'EXTENSIONS' },
  { label: 'LinkedIn', value: 'LINKEDIN' },
  { label: 'Kyckart', value: 'KYCKART' },
  { label: 'Indiamart', value: 'INDIAMART' },
  { label: 'Google Maps', value: 'GOOGLE_MAPS' },
  { label: 'Karnataka One', value: 'KARNATAKA_ONE' },
  { label: 'Gridlines', value: 'GRIDLINES' },
  { label: 'Digitap', value: 'DIGITAP' },
  { label: 'GST', value: 'GST' },
  { label: 'Twitter', value: 'TWITTER' }
];

/**
 * Helper function to get the display label from a source value
 * @param value - The source value (e.g., 'GAS_ELECTRICITY_BILL')
 * @returns The display label (e.g., 'Gas & Electricity Bill') or the original value if not found
 */
export const getSourceLabel = (value: string): string => {
  const option = SOURCE_OF_ADDRESS_OPTIONS.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const primarySource = 'LONGHORN_CIU';
